import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from "react-helmet-async";
import './index.css';
import { BrowserRouter as Router, Routes, Route,} from 'react-router-dom';
import Agb from './pages/Agb/Agb';
import Home from './pages/Home/Home';
import Leistungen from './pages/Leistungen/Leistungen'; 
import Photovoltaik from './pages/Leistungen/Photovoltaik/Photovoltaik';
import Installation from './pages/Leistungen/Installation/Installation';
import Impressum from './pages/Impressum/Impressum'; 
import Landestation from './pages/Leistungen/Landestation/Landestation';
import Contact from './pages/Contact/Contact'; 
import Datenschutz from './pages/Datenschutz/Datenschutz';  
const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/leistungen" element={<Leistungen />} />
                <Route path="/leistungen/photovoltaik" element={<Photovoltaik />} />
                <Route path="/leistungen/installation" element={<Installation />} />
                <Route path="/leistungen/landestation" element={<Landestation />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/agb" element={<Agb />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
        </Router>
    );
};
export default App; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider> 
    <App />
  </HelmetProvider>

); 
